import { Flex, Tabs, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';

export type TInviteTab = 'favorites' | 'worked_with' | 'new_to_you';

export interface ITabConfig {
  value: TInviteTab;
  label: string;
  count: number;
  testId: string;
}

interface ITabHeaderProps {
  activeTab: TInviteTab;
  onTabChange: (tab: TInviteTab) => void;
  tabs: ITabConfig[];
  allSelected: boolean;
  onToggleSelectAll: () => void;
  selectAllVisible: boolean;
}

export const TabHeader = ({
  activeTab,
  onTabChange,
  tabs,
  allSelected,
  onToggleSelectAll,
  selectAllVisible,
}: ITabHeaderProps) => (
  <Tabs
    defaultValue={activeTab}
    value={activeTab}
    onValueChange={(value) => onTabChange(value as TInviteTab)}
  >
    <Flex
      direction="row"
      align="center"
      justify="between"
      data-testid="invite-tab-header"
      style={{ padding: '0px 16px 0 0' }}
    >
      <Tabs.List variant="underline" style={{ gap: 12 }}>
        {tabs.map((tab) => (
          <Tabs.Tab
            key={tab.value}
            value={tab.value}
            label={String(tab.count)}
            data-testid={tab.testId}
            data-cy={tab.testId}
          >
            {tab.label}
          </Tabs.Tab>
        ))}
      </Tabs.List>

      {selectAllVisible && (
        <Typography
          as="span"
          bold
          size="body_large"
          color={colors.secondary[500]}
          data-testid="invite-select-all"
          data-cy="invite-select-all"
          onClick={onToggleSelectAll}
          style={{ cursor: 'pointer', paddingBottom: 8 }}
        >
          {allSelected ? 'Unselect All' : 'Select All'}
        </Typography>
      )}
    </Flex>
  </Tabs>
);
